import { INPUT_LIMITS } from 'const/constants'
import { getZipCodeError } from 'helpers/signIn'
import { isValidLength } from 'helpers/utils/utils'
import type {
  SIAccountNumberErrors,
  SSNErrors,
  ZipCodeErrors
} from 'strings/lang/translations.types'
import { i18n } from 'strings/i18n'

type inputFieldError = SIAccountNumberErrors | SSNErrors | ZipCodeErrors | ''

export const getSSNError = (ssn: string) => {
  let error: SSNErrors | '' = ''
  if (ssn.length === 0) {
    error = 'ssnEmptyError'
  } else if (!isValidLength(ssn, INPUT_LIMITS.SSN)) {
    error = 'ssnInvalidError'
  }
  return error
}

export const getAccountNumberError = (accountNumber: string) => {
  let error: SIAccountNumberErrors | '' = ''
  if (accountNumber.length === 0) {
    error = 'accountNumberEmptyError'
  } else if (!isValidLength(accountNumber, INPUT_LIMITS.ACCOUNT_NUMBER)) {
    error = 'accountNumberInvalidError'
  }
  return error
}

export const isFormValid = (
  accountNumber: string,
  ssn: string,
  zipcode: string
): boolean => {
  return (
    getAccountNumberError(accountNumber) === '' &&
    getSSNError(ssn) === '' &&
    getZipCodeError(zipcode) === ''
  )
}

export const getInputFieldError = (fieldError: inputFieldError) => {
  return fieldError
    ? i18n({
        securedInstallmentsSignIn: fieldError
      })
    : ''
}
